import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import classes from "./PopularDestinations.module.css";
import PopularDestinationCard from "../PopularDestinationCard/PopularDestinationCard";

function LocalDestinations(props) {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadDestinations = async () => {
    setLoading(true);
    let response = await axios.get(
      "https://api.skypicker.com/umbrella/v2/graphql?featureName=OriginDestinationInterlinkingQuery&query=query+OriginDestinationInterlinkingQuery%28+%24locale%3A+Locale+%24limit%3A+Int+%29+%7B+topPopularODLandingPages%28locale%3A+%24locale%2C+limit%3A+%24limit%29+%7B+...PopularFlights_data+%7D+%7D+fragment+PopularFlightCard_data+on+ODLandingPage+%7B+origin+%7B+__typename+name+slugEn+id+%7D+destination+%7B+__typename+legacyId+name+slugEn+id+%7D+%7D+fragment+PopularFlights_data+on+ODLandingPage+%7B+...PopularFlightCard_data+origin+%7B+__typename+id+%7D+destination+%7B+__typename+id+%7D+%7D&variables=%7B%22locale%22%3A%22us%22%2C%22limit%22%3A36%7D"
    );
    if (
      response &&
      response.data &&
      response.data.data.topPopularODLandingPages
    ) {
      setDestinations(response.data.data.topPopularODLandingPages);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   loadDestinations();
  // }, []);

  const handleOnClick = (item) => {
    let originCode = item.origin.id;
    let originName = item.origin.name;

    if (originCode.includes(":")) {
      originName = originCode.split(":")[1];
    }
    props.onSelect &&
      props.onSelect({
        start: { code: originName, name: item.origin.name },
        end: { code: item.destination.legacyId, name: item.destination.name },
      });
  };
  return (
    <div className={classes.control} style={{ display: "none" }}>
      <Typography
        variant="h5"
        style={{ fontSize: "1.875rem" }}
        className={classes["typo-heading"]}
      >
        Popular Routes
      </Typography>

      <Typography component="p" className={classes["typo-sub-heading"]}>
        Check these popular destinations on travelpick.
      </Typography>

      <div className={classes["popular-destinations"]}>
        {destinations &&
          destinations.map((item, id) => {
            return item && item.destination ? (
              <PopularDestinationCard
                key={id}
                handleOnClick={handleOnClick.bind(this, item)}
                item={item}
              />
            ) : (
              <></>
            );
          })}
      </div>
    </div>
  );
}

export default LocalDestinations;
